import * as Yup from 'yup';

export const validationSchema = Yup.object({
  phase: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  })
    .required('Phase is required')
    .nullable(),
  invoiceNumber: Yup.string()
    .matches(RegExp(/^[A-Za-z0-9-.]+$/), {
      excludeEmptyString: true,
      message: 'Please enter a valid number.',
    })
    .required('Invoice Number is required'),
  amount: Yup.number()
    .typeError('Must be a number')
    .min(1, 'Must be greater than 0.')
    .integer('Please enter a valid number')
    .transform((val) => (Number.isNaN(val) ? 0 : val))
    .required('Invoice amount is required'),
  dueDate: Yup.date()
    .transform((curr, orig) => (orig === '' ? null : curr))
    .test({
      message: 'It must be later than current date.',
      test: (val) => {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        if (val) {
          const inputDate = new Date(val);
          inputDate.setHours(0, 0, 0, 0);
          return inputDate >= currentDate;
        }

        return true;
      },
    })
    .nullable()
    .required('Due Date is required'),
  deliverableId: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  }).nullable(),
  milestoneId: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  }).nullable(),
  notes: Yup.string().max(50, 'Character length exceeds 50').nullable(),
  invoiceDocuments: Yup.array().min(1, 'At least one file is required').required('Invoice document is required'),
});
